module.exports = __webpack_public_path__ + "img/tablist.9d01e5ef.svg";